import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-114d8cd5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "page-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavMenu = _resolveComponent("NavMenu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { width: _ctx.asideWidth }, {
          default: _withCtx(() => [
            _createVNode(_component_NavMenu, { isAsideWidth: _ctx.isAsideWidth }, null, 8, ["isAsideWidth"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { class: "page-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_NavHeader, { onIconChange: _ctx.handleIconChange }, null, 8, ["onIconChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, { class: "page-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}